import { useMantineTheme } from '@mantine/core';
import { IconX, IconBuildingBroadcastTower } from '@tabler/icons-react';
import {
  COOLING_DEVICE_TYPE,
  ELECTRIC_DEVICE_TYPE,
  FIRE_SAFETY_DEVICE_TYPE,
  GAS_DEVICE_TYPE,
  HEATING_DEVICE_TYPE,
  LIFTING_DEVICE_TYPE,
  OTHER_DEVICE_TYPE,
  PRESSURE_DEVICE_TYPE,
  VENTILATION_DEVICE_TYPE,
  WEAK_CURRENT_DEVICE_TYPE,
  MEDICAL_DEVICE_TYPE,
} from 'model/DeviceType';
import IconPressure from 'components/device/icons/IconPressure';
import IconBoltFilled from 'components/device/icons/IconBoltFilled';
import IconSectionFilled from 'components/device/icons/IconSectionFilled';
import IconGas from 'components/device/icons/IconGas';
import IconTemperature from 'components/device/icons/IconTemperature';
import IconTransitionTopFilled from 'components/device/icons/IconTransitionTopFilled';
import IconFlameFilled from 'components/device/icons/IconFlameFilled';
import IconCarFanFilled from 'components/device/icons/IconCarFanFilled';
import IconAirCondition from 'components/device/icons/IconAirCondition';
import IconNurseFilled from 'components/device/icons/IconNurseFilled';

/**
 * Parameters of the TypeIcon component.
 */
interface TypeIconProps {
  /**
   * The type ID to determine the appropriate icon.
   */
  typeId: number;

  /**
   * Size of the type icon.
   */
  size?: 'sm' | 'md';
}

/**
 * Renders an icon based on the provided device type
 */
export default function DeviceTypeIcon({ typeId, size = 'sm' }: TypeIconProps) {
  const theme = useMantineTheme();
  const iconSize = size === 'sm' ? 24 : 28;

  switch (typeId) {
    case PRESSURE_DEVICE_TYPE.id:
      return <IconPressure size={iconSize} color={theme.colors.red[8]} />;

    case ELECTRIC_DEVICE_TYPE.id:
      return <IconBoltFilled size={iconSize} color="#6AB93C" />;

    case OTHER_DEVICE_TYPE.id:
      return <IconSectionFilled size={iconSize} color={theme.colors.gray[5]} />;

    case GAS_DEVICE_TYPE.id:
      return <IconGas size={iconSize} color="#FB8932" />;

    case WEAK_CURRENT_DEVICE_TYPE.id:
      return <IconBuildingBroadcastTower size={iconSize} color="#3B99B0" />;

    case HEATING_DEVICE_TYPE.id:
      return <IconTemperature size={iconSize} color="#F8C244" />;

    case LIFTING_DEVICE_TYPE.id:
      return <IconTransitionTopFilled size={iconSize} color="#4ADDC2" />;

    case FIRE_SAFETY_DEVICE_TYPE.id:
      return <IconFlameFilled size={iconSize} color="#F16068" />;

    case VENTILATION_DEVICE_TYPE.id:
      return <IconCarFanFilled size={iconSize} color="#31B9EF" />;

    case COOLING_DEVICE_TYPE.id:
      return <IconAirCondition size={iconSize} color="#4F6AF3" />;

    case MEDICAL_DEVICE_TYPE.id:
      return <IconNurseFilled size={iconSize} color="#33B2B9" />;

    default:
      return <IconX size={iconSize} color={theme.colors.gray[9]} />;
  }
}
